import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import ConfirmDialog from '../../ConfirmDialog';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { getProduct, removeProduct } from '../../hooks/useProducts';

export default function ArchiveProductContainer() {
  const navigate = useNavigate();
  const params = useParams();
  const { org } = useLegacyAppSession();
  const productId = String(params.productId || '');
  const [productName, setProductName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!productId || !org?.id) return;

    let cancelled = false;
    setIsLoading(true);

    getProduct(org.id, productId)
      .then((product) => {
        if (cancelled) return;
        setProductName(product?.name || '');
      })
      .catch(() => {
        if (cancelled) return;
        showToastError('Product could not be loaded.');
        navigate('/products', { replace: true });
      })
      .finally(() => {
        if (cancelled) return;
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [navigate, org?.id, productId]);

  if (!productId) {
    return <Navigate to="/products" replace />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <ConfirmDialog
      title="Archive Product"
      message={`Are you sure you want to archive ${productName || 'this product'}? This hides it from active listings.`}
      onConfirm={async () => {
        try {
          await removeProduct(productId);
          navigate('/products', { replace: true });
        } catch (error) {
          showToastError('Product could not be archived.');
          console.error(error);
        }
      }}
      onCancel={() => navigate('/products', { replace: true })}
      confirmLabel="Archive"
      cancelLabel="Cancel"
      testId="confirm-archive-product"
    />
  );
}
